import { ReactElement } from "react";
import removeWhiteSpaces from "../../../../shared/RemoveWhiteSpaces";
import * as styles from "./FilterItem.module.scss";

export class FilterItemModel {
    constructor(public readonly id: string, public readonly text: string, public readonly iconSvg: string | JSX.Element | undefined = undefined) {}
    getTextForQueryString = (): string => removeWhiteSpaces(this.text) ?? "";
}

interface IFilterItemProps {
    model: FilterItemModel;
    isSelected: boolean;
    onSelectionChange: () => void;
}

export default function FilterItem({ model, isSelected, onSelectionChange }: IFilterItemProps): ReactElement {
    return (
        <span onClick={onSelectionChange} className={isSelected ? styles.selected : ""}>
            {model.iconSvg && typeof model.iconSvg === "string" ? <div dangerouslySetInnerHTML={{ __html: model.iconSvg }}></div> : <div>{model.iconSvg as JSX.Element}</div>}
            {model.text}
        </span>
    );
}
